"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactComponentComponent = _interopRequireDefault(require("react-component-component"));

var _clone = _interopRequireDefault(require("react-icons/lib/fa/clone"));

var _trash = _interopRequireDefault(require("react-icons/lib/fa/trash"));

var _BooleanOp = _interopRequireDefault(require("./sqonPieces/BooleanOp"));

var _utils = require("./utils");

var _config = require("../utils/config");

var _api = _interopRequireDefault(require("../utils/api"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(props) {
  var _props$arrangerProjec = props.arrangerProjectId,
      arrangerProjectId = _props$arrangerProjec === void 0 ? _config.PROJECT_ID : _props$arrangerProjec,
      arrangerProjectIndex = props.arrangerProjectIndex,
      syntheticSqon = props.syntheticSqon,
      getActiveExecutableSqon = props.getActiveExecutableSqon,
      _props$SqonActionComp = props.SqonActionComponent,
      SqonActionComponent = _props$SqonActionComp === void 0 ? function (_ref) {
    var sqonIndex = _ref.sqonIndex,
        isActive = _ref.isActive,
        isSelected = _ref.isSelected;
    return null;
  } : _props$SqonActionComp,
      _props$isActiveSqon = props.isActiveSqon,
      isActiveSqon = _props$isActiveSqon === void 0 ? false : _props$isActiveSqon,
      _props$isSelected = props.isSelected,
      isSelected = _props$isSelected === void 0 ? false : _props$isSelected,
      _props$index = props.index,
      index = _props$index === void 0 ? 0 : _props$index,
      _props$FieldOpModifie = props.FieldOpModifierContainer,
      FieldOpModifierContainer = _props$FieldOpModifie === void 0 ? undefined : _props$FieldOpModifie,
      _props$api = props.api,
      api = _props$api === void 0 ? _api["default"] : _props$api,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$getColorForRef = props.getColorForReference,
      getColorForReference = _props$getColorForRef === void 0 ? function (index) {
    return '';
  } : _props$getColorForRef,
      _props$isReferenced = props.isReferenced,
      isReferenced = _props$isReferenced === void 0 ? false : _props$isReferenced,
      _props$isIndexReferen = props.isIndexReferenced,
      isIndexReferenced = _props$isIndexReferen === void 0 ? function (index) {
    return false;
  } : _props$isIndexReferen,
      _props$isDeleting = props.isDeleting,
      isDeleting = _props$isDeleting === void 0 ? false : _props$isDeleting,
      _props$dependentIndic = props.dependentIndices,
      dependentIndices = _props$dependentIndic === void 0 ? [] : _props$dependentIndic,
      _props$onSqonCheckedC = props.onSqonCheckedChange,
      onSqonCheckedChange = _props$onSqonCheckedC === void 0 ? function () {} : _props$onSqonCheckedC,
      _props$onSqonDuplicat = props.onSqonDuplicate,
      onSqonDuplicate = _props$onSqonDuplicat === void 0 ? function () {} : _props$onSqonDuplicat,
      _props$onSqonRemove = props.onSqonRemove,
      onSqonRemove = _props$onSqonRemove === void 0 ? function () {} : _props$onSqonRemove,
      _props$onSqonChange = props.onSqonChange,
      onSqonChange = _props$onSqonChange === void 0 ? function (sqon) {} : _props$onSqonChange,
      _props$onActivate = props.onActivate,
      onActivate = _props$onActivate === void 0 ? function () {} : _props$onActivate,
      _props$onDeleteConfir = props.onDeleteConfirmed,
      onDeleteConfirmed = _props$onDeleteConfir === void 0 ? function () {} : _props$onDeleteConfir,
      _props$onDeleteCancel = props.onDeleteCanceled,
      onDeleteCanceled = _props$onDeleteCancel === void 0 ? function () {} : _props$onDeleteCancel,
      _props$emptyEntryMess = props.emptyEntryMessage,
      emptyEntryMessage = _props$emptyEntryMess === void 0 ? null : _props$emptyEntryMess;
  var referenceColor = getColorForReference(index);
  var initialState = {
    hoverring: false
  };

  var hoverStart = function hoverStart(s) {
    return function (e) {
      s.setState({
        hoverring: true
      });
    };
  };

  var hoverEnd = function hoverEnd(s) {
    return function (e) {
      s.setState({
        hoverring: false
      });
    };
  };

  var onFieldOpRemove = function onFieldOpRemove(removedPath) {
    return onSqonChange((0, _utils.removeSqonPath)(removedPath)(syntheticSqon));
  };

  var onLogicalOpChanged = function onLogicalOpChanged(changedPath, newSqon) {
    return onSqonChange((0, _utils.setSqonAtPath)(changedPath, newSqon)(syntheticSqon));
  };

  return /*#__PURE__*/_react["default"].createElement(_reactComponentComponent["default"], {
    initialState: initialState
  }, function (s) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      onMouseEnter: hoverStart(s),
      onMouseLeave: hoverEnd(s),
      className: "sqonEntry ".concat(isActiveSqon ? 'active' : ''),
      onClick: onActivate
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "activeStateIndicator",
      style: !isReferenced ? {} : {
        background: referenceColor
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "selectionContainer",
      onClick: onSqonCheckedChange
    }, /*#__PURE__*/_react["default"].createElement("input", {
      readOnly: true,
      type: "checkbox",
      checked: isSelected,
      disabled: disabled
    }), " #", index + 1), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        flex: 1,
        display: 'flex',
        alignItems: 'center'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "sqonView"
    }, (0, _utils.isEmptySqon)(syntheticSqon) ? emptyEntryMessage : (0, _utils.isBooleanOp)(syntheticSqon) && /*#__PURE__*/_react["default"].createElement(_BooleanOp["default"], {
      arrangerProjectId: arrangerProjectId,
      arrangerProjectIndex: arrangerProjectIndex,
      index: 0,
      onFieldOpRemove: onFieldOpRemove,
      onChange: onLogicalOpChanged,
      sqon: syntheticSqon,
      FieldOpModifierContainer: FieldOpModifierContainer,
      api: api,
      getActiveExecutableSqon: getActiveExecutableSqon,
      getColorForReference: getColorForReference,
      isIndexReferenced: isIndexReferenced,
      referencesShouldHighlight: isActiveSqon
    })))), (isActiveSqon || s.state.hoverring) && /*#__PURE__*/_react["default"].createElement("div", {
      className: "actionButtonsContainer"
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: "sqonListActionButton",
      disabled: disabled,
      onClick: onSqonDuplicate
    }, /*#__PURE__*/_react["default"].createElement(_clone["default"], null)), /*#__PURE__*/_react["default"].createElement("button", {
      className: "sqonListActionButton",
      onClick: onSqonRemove
    }, /*#__PURE__*/_react["default"].createElement(_trash["default"], null))), isDeleting && /*#__PURE__*/_react["default"].createElement("div", {
      className: 'actionButtonsContainer deleteConfirmation'
    }, /*#__PURE__*/_react["default"].createElement("div", null, !!dependentIndices.length && /*#__PURE__*/_react["default"].createElement("div", null, "Dependent queries will be deleted."), /*#__PURE__*/_react["default"].createElement("div", null, "Are you sure you want to delete?")), /*#__PURE__*/_react["default"].createElement("button", {
      className: "button cancel",
      onClick: onDeleteCanceled
    }, "CANCEL"), /*#__PURE__*/_react["default"].createElement("button", {
      className: "button delete",
      onClick: onDeleteConfirmed
    }, "DELETE")), /*#__PURE__*/_react["default"].createElement(SqonActionComponent, {
      isHoverring: s.state.hoverring,
      sqonIndex: index,
      isActive: isActiveSqon,
      isSelected: isSelected
    }));
  });
};

exports["default"] = _default;